import React, { ReactNode } from "react";
import { Box } from "@mui/material";

interface HighlightBoxProps {
  isHighlight?: boolean;
  children: ReactNode;
}

const HighlightBox: React.FC<HighlightBoxProps> = ({
  isHighlight = false,
  children,
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: 3,
        ...(isHighlight && {
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: 3,
            border: "5px solid yellow",
            animation: "pulseBorder 1.5s infinite",
            pointerEvents: "none",
          },
        }),
        "@keyframes pulseBorder": {
          "0%": {
            transform: "scale(1)",
            opacity: 1,
          },
          "50%": {
            transform: "scale(1.08)",
            opacity: 1,
          },
          "100%": {
            transform: "scale(1)",
            opacity: 1,
          },
        },
      }}
    >
      {children}
    </Box>
  );
};

export default HighlightBox;
